import { useIntl } from 'react-intl';
import { getAssetUrl } from '../../../../utils/config';
import Options from '../../../atoms/Options';
import './style.scss';

const VIEW_OPTIONS = ['map', 'list'] as const;

export type ViewOption = typeof VIEW_OPTIONS[number];

const ViewOptions = ({ value, onChange }: { value: ViewOption; onChange: (newValue: ViewOption) => void }) => {
  const { formatMessage } = useIntl();

  const options = VIEW_OPTIONS.map(key => ({
    key,
    label: formatMessage({ id: `shipping.collectionPoint.views.${key}` }),
    defaultIcon: getAssetUrl(`collectionPoints/${key}.svg`),
    activeIcon: getAssetUrl(`collectionPoints/${key}Active.svg`),
  }));

  return (
    <div className="collection-point-search-page__view-options">
      <Options
        options={options}
        value={value}
        onChange={onChange as (newValue: string) => void}
        dataTestIdPrefix="collectionPointOptions"
      />
    </div>
  );
};

export default ViewOptions;
